import { z } from 'zod';

/** Non-negative decimal: no sign, no exponent, no leading zero, 1 to 10 decimals. */
export const DECIMAL_PATTERN = /^(0|[1-9]\d{0,14})(\.\d{1,10})?$/;

/**
 * Decimal as a string for prices, lots, pips and percents. Strings avoid binary float rounding
 * on the wire (`1.08523` stays `1.08523`). Proposal, to be validated (C1 spec R6).
 */
export const DecimalStringSchema = z
  .string()
  .regex(DECIMAL_PATTERN, 'Expected a non-negative decimal string')
  .describe('Non-negative decimal as a string, e.g. "1.08523"');
/** Decimal string. */
export type DecimalString = z.infer<typeof DecimalStringSchema>;

/** Decimal string greater than zero (lots, risk percent, pips, prices). */
export const PositiveDecimalSchema = DecimalStringSchema.refine(
  (value) => /[1-9]/.test(value),
  'Expected a value greater than zero',
);
